export class FlightTopBarStates {
  default: FlightTopBarState;
  outbound: FlightTopBarState;
  inbound: FlightTopBarState;

  constructor() {
    this.default = {
      pollingFinished: false,
      sessionExpired: false,
      totalFlightsCount: 0,
      visibleFlightsCount: 0,
    };
    this.outbound = {
      pollingFinished: false,
      sessionExpired: false,
      totalFlightsCount: 0,
      visibleFlightsCount: 0,
    };
    this.inbound = {
      pollingFinished: false,
      sessionExpired: false,
      totalFlightsCount: 0,
      visibleFlightsCount: 0,
    };
  }
}

export interface FlightTopBarState {
  pollingFinished: boolean;
  sessionExpired: boolean;
  totalFlightsCount: number;
  visibleFlightsCount: number;
}
